import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';

import {fetchUserIfNeeded} from '../../../../../actions/app/support/user';
import TableRow from '../../../components/TableRow';
import SupportTitle from '../../../components/title';
import {UserConnexionStyles} from '../../../User/components/Connexion/styles';

const teamStatusesColors = {
  0: 'red',
  1: 'orange',
  2: '#45c945',
};

const DivisionPlayers = ({data, dispatch}) => {
  if (!data) {
    return null;
  }
  return (
    <div style={UserConnexionStyles.container}>
      <SupportTitle title={`division players - ${data.users.length}`} />
      <table className="table table-sm table-responsive table-striped">
        <thead>
          <tr>
            <th>Id</th>
            <th>username</th>
            <th>email</th>
          </tr>
        </thead>
        <tbody>
          {data.users.map(user => {
            return (
              <Fragment>
                {data.status === 3 && (
                  <div
                    style={{
                      position: 'absolute',
                      height: 37,
                      width: 3,
                      backgroundColor:
                        teamStatusesColors[
                          data.mercatoState.teamsStatuses[
                            data.usersTeams[user.id]
                          ]
                        ],
                    }}
                  />
                )}
                <TableRow
                  label={user.id}
                  value={
                    <div
                      style={{cursor: 'pointer', textDecoration: 'underline'}}
                      onClick={() =>
                        dispatch(fetchUserIfNeeded({identifier: user.username}))
                      }>
                      <Link to="/user-support">{user.username}</Link>
                    </div>
                  }
                  action={
                    <div
                      style={{color: 'rgb(142 142 142)', fontWeight: 'normal'}}>
                      {user.email}
                    </div>
                  }
                />
              </Fragment>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default connect(
  () => ({}),
  dispatch => ({dispatch}),
)(DivisionPlayers);



// WEBPACK FOOTER //
// ./src/pages/Support/League/Widgets/DivisionPlayers/index.js